import Navigation from 'components/shared/Navigation/Navigation'
import config from 'config/config'
import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { bindActionCreators } from 'redux'
import { hideSidebar } from 'redux/navigation'
import { Menu } from 'semantic-ui-react'

const mapStateToProps = (state, ownProps) => {
  return {}
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      push,
      hideSidebar,
    },
    dispatch
  )
}

class NavigationMenu extends React.Component {
  render() {
    const { color, items, push, hideSidebar, node, children } = this.props

    const menuItems = items.map((item) => (
      <Menu.Item
        {...{
          active: item.active,
          color: config.semantic_ui.primary_color,
          fitted: true,
          href: item.path,
          key: item.key,
          children: children ? children : item.content,
          onClick: (event) => {
            event.preventDefault()
            push(item.path)
            hideSidebar()
          },
        }}
      />
    ))

    return (
      <Menu color={color} secondary text vertical>
        <Menu.Item>
          <Menu.Header>
            <Navigation render="link" as="text" node={node} />
          </Menu.Header>
          <Menu.Menu>{menuItems}</Menu.Menu>
        </Menu.Item>
      </Menu>
    )
  }
}

NavigationMenu = connect(mapStateToProps, mapDispatchToProps)(NavigationMenu)
export default NavigationMenu



// WEBPACK FOOTER //
// ./src/components/shared/Navigation/renditions/NavigationMenu.jsx